(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-cart-enhancements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let queued = false;
    let observer;
    const config = () => document.querySelector('[data-tm-cart-enhancements-config]');
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: currency || 'EUR' }).format((Number(amount) || 0) / 100);
    const variantIds = (source) => [source.dataset.packOneId, source.dataset.packTwoId, source.dataset.packThreeId];
    const variantPackSize = (variantId, source) => variantIds(source).findIndex((id) => id && id === String(variantId)) + 1;
    const daysPerPack = (source) => Number(source.dataset.daysPerPack) || 80;
    let switchingPack = false;

    function decoratePacks() {
      const source = config();
      if (!source) return;
      document.querySelectorAll('.cart-items__table-row[data-key]').forEach((row) => {
        const selector = row.querySelector('cart-quantity-selector-component');
        const input = selector?.querySelector('input[type="number"]');
        if (!selector || !input) return;
        const size = variantPackSize(selector.dataset.variantId, source);
        if (!size) return;
        const total = size * (Number(input.value) || 1);
        const days = total * daysPerPack(source);
        const duration = `${size * daysPerPack(source)} ${source.dataset.daysLabel}`;
        const variantTerm = row.querySelector('.cart-items__variant dd');
        const variantName = row.querySelector('.cart-items__variant dt');
        if (variantTerm && variantTerm.textContent.trim() !== duration) variantTerm.textContent = duration;
        if (variantName && variantName.textContent.trim() !== 'Durée :') variantName.textContent = 'Durée :';
        selector.classList.add('tm-cart-pack-quantity');
        input.tabIndex = -1;
        input.setAttribute('aria-hidden', 'true');
        const count = selector.querySelector('.tm-cart-pack-quantity__count') || document.createElement('span');
        count.className = 'tm-cart-pack-quantity__count';
        count.setAttribute('role', 'status');
        count.setAttribute('aria-live', 'polite');
        count.setAttribute('aria-label', `${days} ${source.dataset.daysLabel}`);
        if (count.textContent !== String(total)) count.textContent = String(total);
        if (!count.isConnected) selector.append(count);
        const minus = selector.querySelector('.quantity-minus');
        const plus = selector.querySelector('.quantity-plus');
        if (minus) {
          minus.setAttribute('aria-label', size === 1 ? `Retirer ${daysPerPack(source)} ${source.dataset.daysLabel}` : `Passer à ${(size - 1) * daysPerPack(source)} ${source.dataset.daysLabel}`);
          if (!input.disabled) minus.disabled = size === 1 ? Number(input.value) <= 1 : !variantIds(source)[size - 2];
        }
        if (plus) {
          plus.setAttribute('aria-label', `Passer à ${(size + 1) * daysPerPack(source)} ${source.dataset.daysLabel}`);
          if (!input.disabled) plus.disabled = size === 3 || !variantIds(source)[size];
        }
        row.querySelector('.tm-cart-pack-badge')?.remove();
      });
    }

    async function changePack(event) {
      const button = event.target.closest?.('.tm-cart-pack-quantity .quantity-minus, .tm-cart-pack-quantity .quantity-plus');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (button.disabled || switchingPack) return;

      const source = config();
      const row = button.closest('.cart-items__table-row[data-key]');
      const selector = button.closest('cart-quantity-selector-component');
      if (!source || !row || !selector) return;
      const currentSize = variantPackSize(selector.dataset.variantId, source);
      const isPlus = button.matches('.quantity-plus');
      const nextSize = currentSize + (isPlus ? 1 : -1);
      const nextVariantId = variantIds(source)[nextSize - 1];
      if (!currentSize || nextSize < 0 || nextSize > 3 || (nextSize > 0 && !nextVariantId)) return;

      switchingPack = true;
      button.disabled = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
        if (!cartResponse.ok) throw new Error('Lecture du panier impossible');
        const cart = await cartResponse.json();
        const current = cart.items.find((item) => item.key === row.dataset.key);
        if (!current || Number(current.variant_id) !== Number(selector.dataset.variantId)) throw new Error('Le panier a changé');
        const updates = { [current.key]: Math.max(0, Number(current.quantity) - 1) };
        if (nextSize > 0) {
          const existingTarget = cart.items.find((item) => Number(item.variant_id) === Number(nextVariantId));
          if (existingTarget) updates[existingTarget.key] = Number(existingTarget.quantity) + 1;
          else updates[nextVariantId] = 1;
        }
        const updateResponse = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!updateResponse.ok) throw new Error('Mise à jour du panier impossible');
        const destination = new URL(`${root}cart`, window.location.origin);
        const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewThemeId) destination.searchParams.set('preview_theme_id', previewThemeId);
        window.location.assign(destination.href);
      } catch (error) {
        console.error('[PURAIO] Changement de lot impossible', error);
        button.disabled = false;
        switchingPack = false;
        refresh();
      }
    }

    function sachetCount(cart) {
      const source = config();
      if (!source) return { count: Number(cart.item_count) || 0, onlyPuraio: false, hasPack: false };
      if (Array.isArray(cart.items)) {
        const sizes = cart.items.map((item) => ({ size: variantPackSize(item.variant_id, source), quantity: Number(item.quantity) || 0 }));
        return {
          count: sizes.reduce((total, item) => total + (item.size || 1) * item.quantity, 0),
          hasPack: sizes.some((item) => item.size > 0),
          onlyPuraio: sizes.length > 0 && sizes.every((item) => item.size > 0)
        };
      }
      const rows = Array.from(document.querySelectorAll('.cart-page .cart-items__table-row[data-key], .cart-drawer__items .cart-items__table-row[data-key]'));
      const seen = new Set();
      const sizes = rows.filter((row) => {
        if (seen.has(row.dataset.key)) return false;
        seen.add(row.dataset.key);
        return true;
      }).map((row) => ({
        size: variantPackSize(row.querySelector('cart-quantity-selector-component')?.dataset.variantId, source),
        quantity: Number(row.querySelector('cart-quantity-selector-component input[type="number"]')?.value) || 0
      }));
      return sizes.length
        ? {
          count: sizes.reduce((total, item) => total + (item.size || 1) * item.quantity, 0),
          hasPack: sizes.some((item) => item.size > 0),
          onlyPuraio: sizes.every((item) => item.size > 0)
        }
        : { count: Number(cart.item_count) || 0, hasPack: false, onlyPuraio: false };
    }

    function mount() {
      const source = config();
      if (!source) return;
      decoratePacks();
      document.querySelectorAll('.cart-totals').forEach((totals) => {
        const total = totals.querySelector('.cart-totals__container');
        if (!total) return;
        if (!totals.querySelector('.tm-cart-enhancements__rows')) {
          const rows = source.querySelector('[data-tm-cart-rows]').content.firstElementChild.cloneNode(true);
          total.before(rows);
        }
        const drawerItems = totals.closest('.cart-drawer__content')?.querySelector('.cart-drawer__items');
        const trustHost = drawerItems || totals.parentElement;
        const checkoutButtons = totals.nextElementSibling?.matches('.cart__ctas')
          ? totals.nextElementSibling
          : totals.parentElement?.querySelector('.cart__ctas');
        const trust = trustHost.querySelector('.tm-cart-enhancements__trust')
          || source.querySelector('[data-tm-cart-trust]').content.firstElementChild.cloneNode(true);
        if (drawerItems) {
          if (!drawerItems.contains(trust)) drawerItems.append(trust);
        } else if (checkoutButtons && checkoutButtons.nextElementSibling !== trust) {
          checkoutButtons.after(trust);
        }
        const discount = totals.querySelector('.cart-discount details');
        if (discount && !discount.open) discount.open = true;
      });
    }

    function update(cart) {
      const source = config();
      if (!source) return;
      const count = Number(cart.item_count) || 0;
      const sachets = sachetCount(cart);
      const subtotal = money(cart.items_subtotal_price, cart.currency);
      const references = [source.dataset.packOneReference, source.dataset.packTwoReference, source.dataset.packThreeReference].map(Number);
      const referenceTotal = Array.isArray(cart.items) && references[0]
        ? cart.items.reduce((total, item) => {
            const size = variantPackSize(item.variant_id, source);
            return total + (size ? references[size - 1] * Number(item.quantity) : Number(item.original_line_price) || 0);
          }, 0)
        : Number(cart.original_total_price) || 0;
      const savings = Math.max(0, referenceTotal - (Number(cart.total_price) || 0));
      document.querySelectorAll('.tm-cart-enhancements__rows').forEach((rows) => {
        const visibleCount = sachets.onlyPuraio ? sachets.count * daysPerPack(source) : count;
        const singular = sachets.onlyPuraio ? source.dataset.daysLabel : source.dataset.itemSingular;
        const plural = sachets.onlyPuraio ? source.dataset.daysLabel : source.dataset.itemPlural;
        const label = `${source.dataset.subtotalLabel} · ${visibleCount} ${visibleCount === 1 ? singular : plural}`;
        const countEl = rows.querySelector('[data-tm-cart-count]');
        const subtotalEl = rows.querySelector('[data-tm-cart-subtotal]');
        const savingsEl = rows.querySelector('[data-tm-cart-savings]');
        const savingsRow = rows.querySelector('[data-tm-cart-savings-row]');
        if (countEl.textContent !== label) countEl.textContent = label;
        if (subtotalEl.textContent !== subtotal) subtotalEl.textContent = subtotal;
        if (savingsEl.textContent !== money(savings, cart.currency)) savingsEl.textContent = money(savings, cart.currency);
        savingsRow.hidden = savings === 0;
      });
      if (sachets.hasPack) {
        document.querySelectorAll('.cart-page__title .cart-bubble__text-count').forEach((bubble) => {
          if (bubble.textContent !== String(sachets.count)) bubble.textContent = String(sachets.count);
        });
        document.querySelectorAll('.cart-drawer__badge').forEach((badge) => {
          if (badge.textContent !== String(sachets.count)) badge.textContent = String(sachets.count);
          const accessibleCount = badge.nextElementSibling;
          if (accessibleCount?.classList.contains('visually-hidden')) {
            accessibleCount.textContent = `${sachets.count} ${sachets.count === 1 ? source.dataset.packSingular : source.dataset.packPlural} dans le panier`;
          }
        });
      }
    }

    async function refresh() {
      if (!document.querySelector('.cart-totals')) return;
      const source = config();
      if (!source) return;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) return;
        update(await response.json());
      } catch (_) {}
    }

    function schedule() {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        mount();
        refresh();
      }, 120);
    }

    function init() {
      const source = config();
      if (!source) return;
      mount();
      update({
        item_count: source.dataset.itemCount,
        items_subtotal_price: source.dataset.subtotal,
        original_total_price: source.dataset.originalTotal,
        total_price: source.dataset.total,
        currency: source.dataset.currency
      });
      refresh();
      if (!observer) {
        observer = new MutationObserver((mutations) => {
          if (mutations.some((mutation) => {
            const target = mutation.target;
            return target.nodeType === 1 && (
              target.closest?.('.cart-totals, .cart-page__summary, .cart-drawer__summary, cart-items-component') ||
              Array.from(mutation.addedNodes).some((node) => node.nodeType === 1 && (node.matches?.('.cart-totals, .cart-drawer__summary') || node.querySelector?.('.cart-totals')))
            );
          })) schedule();
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    window.addEventListener('click', changePack, true);
    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target.querySelector?.('[data-tm-cart-enhancements-config]')) return;
      document.querySelectorAll('.tm-cart-enhancements__rows, .tm-cart-enhancements__trust').forEach((element) => element.remove());
      init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-product-offer-final"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const option = event.target.closest('.tm-product-offer-final__card input[name="id"]');
    if (!option) return;
    const form = option.closest('.tm-product-offer-final__form');
    const price = form?.querySelector('[data-tm-offer-price]');
    if (price) price.textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-product-reviews"] && !Shopify.designMode) return;
  try {
    
  function initPuraioReviewHeights(root) {
    root.querySelectorAll('.tm-product-reviews__list').forEach((list) => {
      if (list.dataset.heightReady) return;
      const cards = Array.from(list.querySelectorAll('.tm-product-reviews__card'));
      if (!cards.length) return;
      list.dataset.heightReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      let frame = 0;

      const update = () => {
        if (!mobile.matches) {
          list.style.removeProperty('height');
          return;
        }
        const left = list.getBoundingClientRect().left;
        const card = cards.reduce((nearest, candidate) => {
          const candidateDistance = Math.abs(candidate.getBoundingClientRect().left - left);
          const nearestDistance = Math.abs(nearest.getBoundingClientRect().left - left);
          return candidateDistance < nearestDistance ? candidate : nearest;
        }, cards[0]);
        list.style.height = `${Math.ceil(card.getBoundingClientRect().height)}px`;
      };

      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      };

      list.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      const observer = new ResizeObserver(schedule);
      cards.forEach((card) => observer.observe(card));
      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPuraioReviewHeights(document), { once: true });
  } else {
    initPuraioReviewHeights(document);
  }
  document.addEventListener('shopify:section:load', (event) => initPuraioReviewHeights(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-product-testers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-product-count')) {
    customElements.define('tm-product-count', class extends HTMLElement {
      connectedCallback() {
        const raw = (this.dataset.target || '').trim();
        const target = Number(raw.replace(',', '.'));
        if (!Number.isFinite(target) || target < 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const format = value => Number.isInteger(target) ? String(Math.round(value)) : value.toFixed(1).replace('.', ',');
        const start = () => {
          if (this._started) return;
          this._started = true;
          const startTime = performance.now();
          const duration = 1400;
          const tick = now => {
            const progress = Math.min((now - startTime) / duration, 1);
            this.textContent = format(target * (1 - Math.pow(1 - progress, 3)));
            if (progress < 1 && this.isConnected) this._frame = requestAnimationFrame(tick);
            else this.textContent = raw;
          };
          this.textContent = format(0);
          this._frame = requestAnimationFrame(tick);
        };

        if (!('IntersectionObserver' in window)) { start(); return; }
        this._observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) { this._observer.disconnect(); start(); }
        }, { threshold: 0.3 });
        this._observer.observe(this);
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        if (this._frame) cancelAnimationFrame(this._frame);
        this.textContent = this.dataset.target || this.textContent;
        this._started = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
